import React, { FC } from "react";
import Navigation from "./Navigation";

export interface HeaderProps {
  className?: string;
}

const Header: FC<HeaderProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-Header sticky top-0 w-full left-0 right-0 z-40 nc-header-bg ${className}`}
    >
      <Navigation />
    </div>
  );
};

export default Header;
